/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Model_DownloadedInputs */



/**
* | output |
* | --- |
* | "Model downloaded" |
*
* @param {Offline_Sync_Model_DownloadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_model_downloaded = /** @type {((inputs?: Offline_Sync_Model_DownloadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Model_DownloadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèle téléchargé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modell heruntergeladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modello scaricato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Модель загружена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modelo descargado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("模型已下载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("モデルをダウンロード済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मॉडल डाउनलोड हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelo transferido")
	return /** @type {LocalizedString} */ ("Model downloaded")
});